<template>
  <h1>Olá</h1>
</template>
<script>
export default {
  name: "AllProjectsView"
}
</script>